import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { usd } from "@/components/ai/useAiEdits";
import { daysBetween, fmtDay, fmtMonth } from "./helpers";

export default function DailyChart({ sum }) {
  const days = daysBetween(sum.range.start, sum.range.end);
  const monthly = days.length > 92;
  const map = Object.fromEntries((monthly ? sum.by_month : sum.by_day).map((r) => [monthly ? r.month : r.day, r]));
  const keys = monthly ? [...new Set(days.map((d) => d.slice(0, 7)))] : days;
  const data = keys.map((k) => ({ k, label: monthly ? fmtMonth(k) : fmtDay(k), usd: map[k]?.usd || 0, calls: map[k]?.calls || 0 }));
  return (
    <section className="rounded-xl border border-slate-200 bg-white p-5" data-testid="costs-chart">
      <div className="flex items-baseline justify-between gap-3">
        <h2 className="text-base font-semibold text-slate-900">Spesa {monthly ? "mensile" : "giornaliera"}</h2>
        <p className="text-[11px] text-slate-500">USD stimati sul listino</p>
      </div>
      <div className="mt-4 h-56">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 4, right: 4, left: -12, bottom: 0 }}>
            <CartesianGrid vertical={false} stroke="#E2E8F0" />
            <XAxis dataKey="label" tick={{ fontSize: 10, fill: "#64748B" }} tickLine={false} axisLine={false} interval="preserveStartEnd" minTickGap={18} />
            <YAxis tick={{ fontSize: 10, fill: "#64748B" }} tickLine={false} axisLine={false} tickFormatter={(v) => `${v}$`} width={44} />
            <Tooltip cursor={{ fill: "#F1F5F9" }} formatter={(v, n, p) => [`${usd(v)} · ${p.payload.calls} chiamate`, "Spesa"]} labelStyle={{ fontSize: 12 }} contentStyle={{ fontSize: 12, borderRadius: 8 }} />
            <Bar dataKey="usd" fill="#0284C7" radius={[3, 3, 0, 0]} maxBarSize={28} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </section>
  );
}
